module.exports = "https://cdn.realtymogul.com/static/media/icon_growth.c5afac38.svg";